import axios from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API_BASE, withCredentials: true });
export const imageUrl = (id) => `${API_BASE}/images/${id}`;
// Resized WebP variants exist only for our own uploaded images.
export const srcSet = (url) => (url?.startsWith(`${API_BASE}/images/`) ? [400, 800, 1200].map((w) => `${url}?w=${w} ${w}w`).join(", ") : undefined);

export const apiError = (e) => {
  const detail = e?.response?.data?.detail;
  if (!detail) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => `${(d.loc || []).slice(-1)[0] || ""}: ${d.msg}`).join(" ");
  return String(detail);
};
